class Video {
  constructor() {
    const playButtons = Array.prototype.slice.call(
      document.querySelectorAll('.lc-video__thumbnail-container')
    );

    playButtons.forEach((button) => {
      button.addEventListener('click', () => this.play(button));
    });
  }

  play(button) {
    const container = button.parentElement;
    if (!container) {
      return;
    }

    const thumbnail = button.querySelector('.lc-video__thumbnail');
    const iframe = container.querySelector('iframe');
    const htmlvideo = container.querySelector('video');

    if (iframe && iframe.src) {
      iframe.src = this.withAutoplay(iframe.src);
    } else if (htmlvideo) {
      const promise = htmlvideo.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(() => {});
      }
    }

    button.style.display = 'none';
    if (thumbnail) {
      thumbnail.style.display = 'none';
    }
  }

  withAutoplay(src) {
    if (/[?&]autoplay=/.test(src)) {
      return src;
    }

    const separator = src.includes('?') ? '&' : '?';
    return `${src}${separator}autoplay=1`;
  }
}

export default Video;
